import { useState } from "react";
import { useHttpAPI } from "../../common/http/httpServiceAPI";
import { useSession } from "../../common/session/SessionContext";

const useDocumentSubmissionServiceAPI = () => {

  const http = useHttpAPI();
  const [confirmationNumber, setConfirmationNumber] = useState(null);
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const {contextId} = useSession();

  const setUploadUrls = async(categoryOptionId, documents) => {
    const model = {
      categoryOptionId: categoryOptionId,
      documents: documents.map(function(document) {
        return {
          files: document.files.map(function(file) {
            return { fileName: file.name };
          })
        };
      })
    };
    const result = await http.post('/documentuploadurlAPI?contextId=' + contextId, model);

    for (let docIndex = 0; docIndex < documents.length; docIndex++) {
      const docToUpload = documents[docIndex];
      const resultDoc = result.documents[docIndex];

      for (let fileIndex = 0; fileIndex < docToUpload.files.length; fileIndex++) {
        docToUpload.files[fileIndex].blobUrl = resultDoc.files[fileIndex].blobUrl;
      }
    }

    return result.documentSubmissionId;
  };
  
  const postFiles = (documents) => {

    const promises = [];
  
    for (let docIndex = 0; docIndex < documents.length; docIndex++) {
      const document = documents[docIndex];
  
      for (let fileIndex = 0; fileIndex < document.files.length; fileIndex++) {
        const file = document.files[fileIndex];
  
        promises.push(http.request({
          method: 'PUT',
          url: file.blobUrl,
          data: file,
          headers: {
            'Content-Type': file.type,
            'x-ms-blob-type': 'BlockBlob'
          }
        }));
      }
    }
  
    return Promise.all(promises);
  };
  
  const createDocuments = (documentSubmissionId) => {
    return http.post('/documentsubmissionAPI?id='+ documentSubmissionId + '&contextId=' +  contextId);
  };

  const submitDocuments = async(categoryOptionId, documents) => {
    setSubmissionComplete(false);
    try {
      const documentSubmissionId = await setUploadUrls(categoryOptionId, documents);
      await postFiles(documents);
      const confirmation = await createDocuments(documentSubmissionId);
      setConfirmationNumber(confirmation);
    }
    finally {
      setSubmissionComplete(true);
    }
  }
  
  return { submitDocuments, confirmationNumber, submissionComplete };
};

export { useDocumentSubmissionServiceAPI };